var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF7F7",
    d: "M4.045 23.821V25.2a2.325 2.325 0 0 0 2.325 2.325h1.916c.102.01.184.09.184.193v2.675a.2.2 0 0 0 .322.16l3.999-2.996a.2.2 0 0 1 .098-.032l6.725-.009a2.324 2.324 0 0 0 2.324-2.325v-3.314h.644l5.625 3.867v-5.511h1.441a2.74 2.74 0 0 0 2.736-2.736V7.611a2.74 2.74 0 0 0-2.736-2.736H14.525a2.74 2.74 0 0 0-2.735 2.736v7.212H6.498a2.453 2.453 0 0 0-2.453 2.453z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "teal",
    fillRule: "evenodd",
    d: "M17.36 21.895v-2.86h1.41v2.86a2.377 2.377 0 0 1-2.376 2.377h-7.09a.2.2 0 0 0-.101.033l-4.088 3.063a.205.205 0 0 1-.33-.163v-2.736a.2.2 0 0 0-.187-.197H3.484a2.377 2.377 0 0 1-2.378-2.377v-7.942a2.376 2.376 0 0 1 2.377-2.376H6.84v1.41H3.483a.967.967 0 0 0-.966.966v7.942c0 .532.433.967.967.967h1.184l.07.006a1.61 1.61 0 0 1 1.458 1.601v.327l2.16-1.62a1.6 1.6 0 0 1 .782-.304l.083-.01h7.173a.967.967 0 0 0 .965-.967zM27.1 1.72a2.8 2.8 0 0 1 2.797 2.797v9.693a2.8 2.8 0 0 1-2.796 2.797h-1.61v3.953l-5.277-3.953h-8.575a2.8 2.8 0 0 1-2.796-2.797V4.517A2.8 2.8 0 0 1 11.64 1.72h15.462zm1.387 12.49V4.517c0-.765-.623-1.386-1.386-1.386H11.639c-.765 0-1.385.621-1.385 1.386v9.693c0 .765.62 1.387 1.385 1.387h9.045l3.397 2.544v-2.544h3.02c.763 0 1.386-.622 1.386-1.387",
    className: "icon-teal",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.006,
    cy: 9.245,
    r: 1.064,
    fill: "teal",
    className: "icon-teal"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.18,
    cy: 9.245,
    r: 1.064,
    fill: "teal",
    className: "icon-teal"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.353,
    cy: 9.245,
    r: 1.064,
    fill: "teal",
    className: "icon-teal"
  })));
};
export default SvgChat;